<template>
  <!-- common-padding  -->
  <section
    id="testimonials-section"
    class="relative mx-auto py-0 min-h-svh overflow-y-clip -translate-y-0 will-change-transform common-padding"
  >
    <div
      class="grid grid-cols-12 pb-[clamp(2.25rem,2.1786rem_+_0.3571vi,2.5rem)] border-flax-smoke-300 border-b-[1px] w-full"
    >
      <h3
        class="col-span-full font-bold text-flax-smoke-950 uppercase leading-none will-change-auto heading-1 max-sm:heading-2"
      >
        See What Others  <br />
      Are Saying
      </h3>
      <div
        class="flex justify-end gap-10 sm:gap-20 col-span-full lg:col-span-10 mt-[5%] text-flax-smoke-800"
      >
        <p class="text-center uppercase text-nowrap heading-6">
          ( Testimonials )
        </p>
        <p class="w-full sm:max-w-[40ch] font-fancy text-balance heading-6">
Here’s what my clients say about working with me. Their satisfaction and meeting project goals are always my top priorities. I’m committed to delivering the best experience every time.
        </p>
      </div>
    </div>

    <Slider />
  </section>
</template>

<script setup lang="ts">
  // import gsap from 'gsap';
  // import { ScrollTrigger } from 'gsap/all';
  // import { onMounted } from 'vue';
  import { Slider } from '../design';

  // gsap.registerPlugin(ScrollTrigger);

  // const animatePeopleSectionLeave = (id: string) => {
  //   gsap.to(id, {
  //     scrollTrigger: {
  //       trigger: id,
  //       markers: true,
  //       start: 'top 80%',
  //       end: '100% end',
  //     },
  //     duration: 0.7,
  //     y: '0',
  //   });
  // };
  // onMounted(() => {
  //   animatePeopleSectionLeave('#testimonials-section');
  // });
</script>
